import { HttpClient } from '@angular/common/http';
import { Component, OnDestroy, OnInit, Input, Output, EventEmitter, Inject } from '@angular/core';
import { ActivatedRoute, ParamMap, Router } from '@angular/router';
import { DomainCodes } from '../../../models/const.DomainCodes';
import { CommonData } from '../../_infrastructure/CommonData/CommonDataResolver';
import { TableEditBase } from '../../_infrastructure/TableEdit/TableEditBase';
import { PreStageDocumentationComponent } from './prestage-documentation.component';
import { isNullOrUndefined } from '../../_infrastructure/objectUtils';
import { DocumentVMExtension } from '../../workflows/cards/Documentation/IDocumentation';
import { ControlContainer, NgForm } from '@angular/forms';
import { ModalService } from '../../_infrastructure/Modal/ModalService';
import { DocumentsHandlerService } from '../../_infrastructure/Documents/DocumentHandlerService';
import { map } from 'rxjs/operators';
import { AlertService } from '../../_infrastructure/Alerts/alert.service';
import { LoadingMaskService } from '../../_infrastructure/LoadingMask/LoadingMaskService';
import { SubscriberInformationService } from '../../_infrastructure/SubscriberInfo/SubscriberInformationService';
import { Subscriber, Subscription } from 'rxjs';
import { isNumber } from 'ngx-bootstrap/chronos/utils/type-checks';
import { CommonDataService } from '../../_infrastructure/CommonData/CommonDataService';
import { UtilsService } from '../../_infrastructure/Utils/UtilsService';
// https://stackoverflow.com/questions/78706152/unable-to-load-pdfjs-dist-library-in-angular-but-same-thing-working-in-js
import * as pdfjsLib from 'pdfjs-dist/build/pdf.min.mjs';
// import * as pdfjsLib from 'pdfjs-dist/build/pdf';

@Component({
    selector: 'prestage-documentation-table-edit',
    templateUrl: './prestage-documentation-table-edit.component.html',
    viewProviders: [{ provide: ControlContainer, useExisting: NgForm }],
    standalone: false
})
export class PreStageDocumentationTableEditComponent extends TableEditBase<DocumentVMExtension> implements OnInit, OnDestroy {

  @CommonData(DomainCodes.domains)
  public domains: models.DimensionVM[];
  @CommonData(DomainCodes.fileTypes)
  public fileTypes: models.DimensionVM[];
  @CommonData(DomainCodes.documentDesignationType)
  public designationTypes: models.DimensionVM[];

  @Input() public isMandatoryDocumentation : boolean;
  @Input() public isWorkflowOnSubscriber : boolean;
  @Input() public isIncapacity: boolean = false;
  @Input() public isWorkflowMandatory: boolean = false;
  public uploadedFile: File;

  @Input() public workflowInstanceId: number;

  public subscriber: models.SubscriberInformationVM;
  public invalidFileFormat: boolean = false;
  public invalidExceedsFileSize: boolean = false;
  public invalidFileSize: boolean = false;
  public invalidPDFFile: boolean = false;

  private MAX_FILE_SIZE: number = 8388608;

  @Input() public dropdowns: models.WorkflowDropdownsVM = null;
  private mainSubscription: Subscription = new Subscription();

  constructor(@Inject(PreStageDocumentationComponent) private parent: Component, private modalService: ModalService,
    private documentService: DocumentsHandlerService, private alertService: AlertService, private http: HttpClient, private router: Router,
    private activeRoute: ActivatedRoute, private loadingMaskService: LoadingMaskService, private subscriberInfoService: SubscriberInformationService,
    private commonDataService: CommonDataService, private utilsService: UtilsService) {
    super(parent, modalService);


    this.subscriberInfoService.getCurrentSubscriber().subscribe((subscriber) => {
      this.subscriber = subscriber;
    });
    // resolve CommonData as of angular version 18 is broken
    const domainCodes: string[] = [
      DomainCodes.domains,
      DomainCodes.fileTypes,
      DomainCodes.documentDesignationType
    ];
    this.mainSubscription.add(
      this.commonDataService.getDomains(domainCodes).subscribe(results => {
        this.domains = this.utilsService.getDomainOfDomains(DomainCodes.domains, results).dimensions;
        this.fileTypes = this.utilsService.getDomainOfDomains(DomainCodes.fileTypes, results).dimensions;
        this.designationTypes = this.utilsService.getDomainOfDomains(DomainCodes.documentDesignationType, results).dimensions;
      })
    ); 

  }

  ngOnInit(): void {
    super.ngOnInit();
    this.uploadedFile = null;
  }

  ngOnDestroy(): void {
    if (this.mainSubscription) {
      this.mainSubscription.unsubscribe();
    }
  }

  isVersion2() {
    let result = false;
    if (true) {
      result = true;
    }
    return result;
  }

  onFileSelected(event: any) {
    this.setFile(event.target.files[0]);
  }

  onFileDropped(file: File) {
    this.setFile(file);
  }

  private async setFile(file: File) {
    this.invalidFileFormat = false;
    this.invalidFileSize = false;
    this.invalidPDFFile = false;

    if (!this.validatePDFFile(file)) {
      this.invalidFileFormat = true;
      return;
    } else if (this.validatePDFExceedsFileSize(file)) {
      this.invalidExceedsFileSize = true;
      return;
    } else {
      let fileCheck = await this.checkIfFileIsEmpty(file);
      if (fileCheck === "EmptyPDF") {
        this.invalidFileSize = true;
        return;
      } else if (fileCheck === "InvalidPDF") {
        this.invalidPDFFile = true;
        return;
      } 
    }

    this.uploadedFile = file;
    this.item.fileName = this.uploadedFile.name;
    this.item.fileSizeKB = Math.round(this.uploadedFile.size / 1024);
    this.item.file = this.uploadedFile;
    if (!this.item.filePath) {
      this.item.filePath = this.uploadedFile.name;
    }
    
  }

  private validatePDFFile(file: File) {
    return file.type === 'application/pdf';
  }

  private validatePDFExceedsFileSize(file: File) {
    return file.size > this.MAX_FILE_SIZE;
  }

  private async checkIfFileIsEmpty(file: File): Promise<string> {
    pdfjsLib.GlobalWorkerOptions.workerSrc = "pdf.worker.mjs";
    if (!(<any>Promise).try) {
      (<any>Promise).try = (fn, ...args) => new Promise((res, rej) => {
        try { res(fn(...args)); } catch (e) { rej(e); }
      });
    }
    var fileReader = new FileReader();
    if (file.type === 'application/pdf') {
      fileReader.readAsArrayBuffer(file);

      return new Promise(function (resolve, reject) {
        fileReader.onloadend = async function (ev) {
          let base64Data = fileReader.result as ArrayBuffer;
          const countPromises = [];

          if (base64Data.byteLength != 0) {
            //Códigos dos possíveis objetos de imagens presentes em ficheiros PDF
            var pdfImgObjCodes = [74, 75, 83, 84, 89, 85, 88, 86, 87, 82, 90, 66];

            let pdfProcessing: Int8Array = new Int8Array(base64Data as ArrayBuffer);
            const pdf = await pdfjsLib.getDocument(pdfProcessing);
            try {
              for (let i = 1; i <= (await pdf.promise).numPages; i++) {
                const page = await (await pdf.promise).getPage(i);

                //Verificar se o ficheiro PDF contém conteúdo de texto
                const textContent = await page.getTextContent();
                countPromises.push(textContent.items.map((s: any) => s.str).join(''));

                //Verificar se o ficheiro PDF contém conteúdo de imagens
                const imgContent = await page.getOperatorList();
                imgContent.fnArray.map(q => {
                  if (pdfImgObjCodes.includes(q))
                    countPromises.push('Img');
                });
              }
            } catch (e) {
              resolve("InvalidPDF");
            }
          } else {
            resolve("EmptyPDF");
          }

          await Promise.all(countPromises).then(function (e) {
            let pdfContent = e.join('');

            if (pdfContent !== ' ') {
              resolve("ValidPDF");
            } else {
              resolve("EmptyPDF");
            }
          })
        }
      })

    }
  }


  emitListChange(isEdit: boolean): void {
    if(!isEdit) this.item.isMandatoryFile = this.item.designationTypeCode === "MDP170" && !this.isNotTheOnly();
    this.itemList = this.itemList || [];
    if (isEdit)
      this.itemList.splice(this.editIndex, 1, this.item);
    else
      this.itemList.push(this.item);

    this.listChanged.emit(this.itemList);
  }

  onEdit(isEdit: boolean) {
    // PIT 40802 \\
    this.http.get<models.WorkflowStatusVM[]>('api/Workflow/ValidaDisponibilidadePGPCall', {}).subscribe((result: any) => {

      if (result.stateCode == 'I') {
        this.router.navigate(['validatepgponline']);
        return;
      } // PIT 40802 \\
      else {

        //Necessário setar o touched em todos os inputs no seguinte de forma a que as mensagens de erro apareçam
        super.markTouched();

        if (!super.checkValid())
          return;

        //If a file was uploaded
        if (!isNullOrUndefined(this.uploadedFile)) {
          this.loadingMaskService.setShowLoading(true, false);
          this.documentService.UploadFile(this.uploadedFile, this.workflowInstanceId.toString(), this.subscriber.numUtente, this.item.designationTypeCode).subscribe(result => {
            this.loadingMaskService.setShowLoading(false);
            if (result.stateCode == "OK") {
              this.item.fileID = result.fileID.toString();
              if (!isEdit) this.item.isMandatoryFile = false;
              this.emitListChange(isEdit);
            }
            else {
              this.alertService.error(result.message);
            }
          }, error => this.loadingMaskService.setShowLoading(false));
        }
        else {
          this.emitListChange(isEdit);
        }
      }
    },
      error => this.loadingMaskService.setShowLoading(false)
    );
  }

  onRemove(isEdit: boolean) {
    // PIT 40802 \\
    this.http.get<models.WorkflowStatusVM[]>('api/Workflow/ValidaDisponibilidadePGPCall', {}).subscribe((result: any) => {

      if (result.stateCode == 'I') {
        this.router.navigate(['validatepgponline']);
        return;
      } // PIT 40802 \\
      else {

        var listToAlter = [...this.itemList];

        if (this.isEdit) {
          if (this.isTrue(this.item.isMandatoryFile.toString()) || this.isNotTheOnly()) {
            if (!this.isTrue(this.item.isMandatoryFile.toString())) {
              listToAlter.splice(this.editIndex, 1);
            } else {
              var itemInList = listToAlter.find(el => el.fileID == this.item.fileID);
              if (itemInList !== null || itemInList !== undefined) {
                itemInList.fileID = "0";
                itemInList.file = null;
                itemInList.fileSizeKB = null;
                itemInList.fileName = null;
              }
              this.item.fileID = "0";
              this.item.file = null;
              this.item.fileSizeKB = null;
              this.item.fileName = null;
            }

            this.listChanged.emit(listToAlter);
          } else {
            this.onClearFile(this.isEdit, null);
            if (!this.isTrue(this.item.isMandatoryFile.toString())) {
              listToAlter.splice(this.editIndex, 1);
            }
          }

        }

        this.listChanged.emit(listToAlter);

      }
    },
      error => this.loadingMaskService.setShowLoading(false)
    );
  }

  private isTrue(value: string) {
    return value == "True" || value == 'true' || value == '1';
  }

  isNotTheOnly(): boolean {
    var listToAlter = [...this.itemList];
    if (!this.isEdit) listToAlter.push(this.item);
    const allMandatoryFiles = listToAlter.filter(el => el.designationTypeCode == "MDP170");
    let result = false;
    if (allMandatoryFiles.length > 1) {
      result = true;
    }
    return result;
  }

  downloadDocument() {
    if (!isNullOrUndefined(this.item.fileID) && this.item.fileID != "" && this.item.fileID != "0")
      this.documentService.DownloadFile(this.item.fileID, this.item.fileName, this.workflowInstanceId.toString(), this.subscriber.subscriberNumber);
  }

 clearItem(itm: DocumentVMExtension) {
    itm.fileName = '';
    itm.file = null;
    itm.fileID = "0";
    itm.fileSizeKB = 0;
    itm.name = "";
    itm.observation = "";
    itm.filePath = "";
}

  onClearFile(isEdit: boolean, evt: Event) {
    // PIT 40802 \\
    this.http.get<models.WorkflowStatusVM[]>('api/Workflow/ValidaDisponibilidadePGPCall', {}).subscribe((result: any) => {

      if (result.stateCode == 'I') {
        this.router.navigate(['validatepgponline']);
        return;
      } // PIT 40802 \\
      else {

        if (!this.isEdit && (this.item.fileID != null || this.item.fileID != undefined)) return false;

        this.uploadedFile = null;

        this.clearItem(this.item);

        if ((this.editIndex !== null) && !isNaN(this.editIndex)) {
          this.clearItem(this.itemList[this.editIndex]);

        }
        if (evt) {
          evt.preventDefault();
          evt.stopPropagation();
        }

        return true;
      }
    },
      error => this.loadingMaskService.setShowLoading(false)
    );
  }


  public removeDisabled(): boolean {
    if (!this.isEdit) return false;

    if (!this.isMandatoryDocumentation) return false;

    return (this.item.isMandatoryFile.toString().toLowerCase() == 'true');

  }


  shouldEditName(code: string) {
    return code == 'ECL000' || code == 'MDP130' || code == 'MPO000';
  }

  sortDesignationType(a, b) {
    if (b.code == 'MDP130')
      return -1;
    if (a.code == 'MDP130')
      return 1;
    return a.description - b.description;
  }

  getFilteredDesignationTypes() {

    
      let result = [];
      for (let i = 0; i < this.dropdowns.options.length; i++) {
        if (this.dropdowns.options[i]['dropdown'] === 'dropListDocumentsPS') {
          result.push(this.dropdowns.options[i]);
        }
      }
      return result;
    

  }

  docDesignationChanged() {
    var dropdown = this.getFilteredDesignationTypes();
    for (let i = 0; i < dropdown.length; i++) {
      if (dropdown[i].value === this.item.designationTypeCode) {
        this.item.description = dropdown[i].description;
      }
    }
  }

}


